dmx.Component('serverconnect', {
    extends: 'fetch'
});
